export const MOUSE_WHEEL_CONFIG = {
  enabled: true,
  forceToAxis: true,
  sensitivity: 1,
  eventsTarget: "container",
};

export const SWIPERS = {
  GALLERY: {
    selector: ".swiper-box .swiper--gallery",
    options: {
      slidesPerView: "auto",
      spaceBetween: 20,
      mousewheel: MOUSE_WHEEL_CONFIG,
      loop: true,
      // centeredSlides: true,
    },
  },
};
